<template>
    <div class="delivery-sec__body">
        <div class="delivery-sec__content-wrapper">
            <h1 class="delivery-sec__title" style="line-height: 21px;"><span
                id="docs-internal-guid-e55d9ff3-7fff-2091-f401-19bab80c6056"><p dir="ltr"
                                                                                style="line-height:1.38;margin-top:0pt;margin-bottom:0pt;"><br></p></span>
            </h1>
            <div><span
                style="background-color: transparent; font-size: 11pt; font-family: Arial, sans-serif; white-space-collapse: preserve;">{{ trans("We collaborate with several reputable international shipping companies known for their safety, efficiency, and reliability") }}.
<br><h2 dir="ltr" style="margin-top: 0pt; margin-bottom: 36pt; line-height: 1.44;"><span
                    style="font-size: 11pt; font-family: Arial, sans-serif; background-color: transparent; font-weight: 400; font-variant-numeric: normal; font-variant-east-asian: normal; font-variant-alternates: normal; font-variant-position: normal; vertical-align: baseline; white-space-collapse: preserve;">{{ trans("Delivery time and costs are calculated automatically upon check-out") }}.</span></h2></span>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
